import Label from '@/components/core/label';
import { ChoicesOrderItemLabel } from '@/types/order';
import { MilestoneToBeBilled } from '@/services/billing/types/billing.type';
import { Box, Table, TableRow, TableBody, TableCell, Typography } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { ChoicesOrderItemType } from '@/sections/management/accounts/orders/types';
import { useDecimalFormatter } from '@hooks/index';

interface MilestoneDetailRowProps {
  milestone: MilestoneToBeBilled;
}

export const MilestoneDetailRow = ({ milestone }: MilestoneDetailRowProps) => {
  const { t, i18n } = useTranslation();
  const formatter = useDecimalFormatter(i18n.language);

  return (
    <Box sx={{ margin: 1 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, pl: 2 }}>
        {t('Milestone')} {milestone.milestonePeriod}
      </Typography>

      <Table size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
        <colgroup>
          <col style={{ width: '40%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '25%' }} />
          <col style={{ width: '25%' }} />
        </colgroup>
        <TableBody>
          <TableRow>
            <TableCell sx={{ border: 0, pl: 4, verticalAlign: 'middle' }}>
              <Typography variant="body2" color="textSecondary" sx={{ ml: 2 }}>
                {t('Date')}: {moment(milestone.paymentDate).utc().format('L')}
                {' | '}
                {t('Status')}: {t(milestone.status)}
                <Label
                  sx={{ ml: 2 }}
                  color={
                    milestone.orderItem?.orderItemType === ChoicesOrderItemType.newResource
                      ? 'primary'
                      : 'secondary'
                  }
                  variant="outlined"
                >
                  {milestone.orderItem?.orderItemType
                    ? t(ChoicesOrderItemLabel[milestone.orderItem.orderItemType])
                    : ChoicesOrderItemLabel.billingCloud}
                </Label>
              </Typography>
            </TableCell>

            <TableCell sx={{ border: 0, verticalAlign: 'middle' }} />

            <TableCell align="center" sx={{ border: 0, verticalAlign: 'middle' }}>
              <Typography variant="body2">{milestone.orderItem.quantity}</Typography>
            </TableCell>

            <TableCell align="center" sx={{ border: 0, verticalAlign: 'middle' }}>
              <Typography variant="body2">$ {formatter.format(milestone.total || 0)}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};
